import { AppTheme } from "../../types/theme";
import { THEME_PALETTE } from "./palette";
import { THEME_SIZING } from "./sizing";

const theme: AppTheme = {
  sizing: THEME_SIZING,
  color: THEME_PALETTE,
};

export default theme;